var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"MainView"},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1),_c('ModalLogs'),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dialogdk",attrs:{"id":"dialogdk"}},[_c('section',{attrs:{"id":"dialogdkbox"}})])
}]

export { render, staticRenderFns }